import { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Set_Loader } from "../Redux/Action/LoaderAction";
import { toast } from "react-toastify";

const useGet = (url) => {
    const Dispatch = useDispatch();
    const Navigate = useNavigate()
    var myHeaders = new Headers();
    myHeaders.append(
        "Authorization",
        `Bearer ${localStorage?.getItem('TEACHER_TOKEN')}`
    );

    var requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
    };
    const [data, setdata] = useState(null);
    const [error, seterror] = useState("");

    const refetch = useCallback((data) => {
        Dispatch(Set_Loader(true))
        fetch(data != '' ? data : url, requestOptions)
            .then((r) => r.json().then((data) => ({ status: r.status, body: data })))
            .then((obj) => {
                setdata(obj);
                switch (obj.status) {
                    case 200:
                        // setdata(obj.body);
                        break;
                    case 400:
                        toast.error(obj?.body?.message);
                        toast.clearWaitingQueue();
                        Dispatch(Set_Loader(false))
                        break;
                    case 401:
                        toast.error("Unauthorized");
                        toast.clearWaitingQueue();
                        Dispatch(Set_Loader(false))
                        Navigate('/login')
                        break;
                    case 403:
                        toast.error("Unauthorized");
                        toast.clearWaitingQueue();
                        Dispatch(Set_Loader(false))
                        Navigate('/login')
                        break;
                    default:
                        Dispatch(Set_Loader(false))
                        break;
                }
                seterror(false)
                // Dispatch(Set_Loader(false))

            }).catch((err) => {
                seterror(true)
                Navigate('/login')
                toast.error("Try again ! Something went wrong");
                toast.clearWaitingQueue();
                Dispatch(Set_Loader(false))

            })
    }, [url]);

    return { data, error, refetch };
};

export default useGet;